import classNames from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getMainDealShareButtons } from '../../config/social/config';
import {
  getDealPointsData,
  updateLocalStorageDeals,
} from '../../helpers/clubWowcher';
import ThemeContext from '../../providers/ThemeProvider';
import { sendRewardShareDealPoints } from '../../services/clubWowcher';
import SocialMediaShareButton from '../footer/SocialMediaShareButton';
import MainDealNativeShare from './MainDealNativeShare';

const MainDealShare = ({ deal, className }) => {
  const theme = useContext(ThemeContext);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const router = useRouter();

  if (!deal || !deal.shareUrl) {
    return null;
  }

  const buttons = getMainDealShareButtons(deal);

  const handleOnClick = (publisherSource) => {
    const { asPath } = router;
    const hasDealPoints = deal?.id && !asPath.includes('dealPreview');
    const dealId = deal.id;

    if (isAuthenticated && hasDealPoints) {
      const dealToShareData = getDealPointsData(
        'shareDeal',
        publisherSource,
        dealId,
      );
      sendRewardShareDealPoints(dealToShareData);
    } else {
      updateLocalStorageDeals('shareDealData', dealId, publisherSource);
    }
  };

  return (
    <>
      <div className={classNames('share', className)}>
        {buttons.map((button) => (
          <SocialMediaShareButton
            ariaLabel={button.ariaLabel}
            backgroundColor={button.backgroundColor}
            className="compact mobile-friendly margin"
            customOnClick={() => handleOnClick(button.key)}
            href={button.href}
            icon={button.icon}
            key={button.key}
            popup={button.popup}
          />
        ))}
        <MainDealNativeShare deal={deal} />
      </div>
      <style jsx>{`
        .share {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }

        @media (min-width: ${theme.breakpoints.smUp}) {
          :global(.main-deal-travel
              .deal-main-deal__actions
              .share
              a.share-button) {
            width: 28px;
            height: 28px;
          }
        }
      `}</style>
    </>
  );
};

MainDealShare.propTypes = {
  className: PropTypes.string,
  deal: PropTypes.object,
};

MainDealShare.defaultProps = {
  className: '',
  deal: null,
};

export default MainDealShare;
